(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6254],{

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 35023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ postGoogleWallet; },
/* harmony export */   "T": function() { return /* binding */ postAppleWallet; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93162);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65885);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65599);





var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z();
function postGoogleWallet(_x) {
  return _postGoogleWallet.apply(this, arguments);
}

function _postGoogleWallet() {
  _postGoogleWallet = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(card) {
    var authorization, headers, body, response, googleJwt, _error$response, _error$response$data, userMessage;

    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authorization = cookies.get('token');
            headers = {
              appId: "kritikos-web",
              authorization: "Bearer ".concat(authorization)
            };
            body = {
              cardNumber: card
            };
            _context.prev = 3;
            _context.next = 6;
            return _config__WEBPACK_IMPORTED_MODULE_2__/* .wave.post */ .t.post('/v3/users/mobile-passes/google-wallet', body, {
              headers: headers
            });

          case 6:
            response = _context.sent;
            googleJwt = response.data.googleJwt;
            return _context.abrupt("return", {
              googleJwt: googleJwt
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            userMessage = ((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.userMessage) || 'Δεν μπορέσαμε να προσθέσουμε την κάρτα σου! Προσπάθησε ξανά μέσα από τη σελίδα του προφίλ σου.';
            return _context.abrupt("return", {
              googleJwt: {},
              gWalletError: userMessage
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11]]);
  }));
  return _postGoogleWallet.apply(this, arguments);
}

function postAppleWallet(_x2) {
  return _postAppleWallet.apply(this, arguments);
}

function _postAppleWallet() {
  _postAppleWallet = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(card) {
    var authorization, headers, body, responseType, response, data, type, passData, _error$response2, _error$response2$data, userMessage;

    return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            authorization = cookies.get('token');
            headers = {
              appId: "kritikos-web",
              authorization: "Bearer ".concat(authorization)
            };
            body = {
              cardNumber: card
            };
            responseType = 'arraybuffer';
            _context2.prev = 4;
            _context2.next = 7;
            return _config__WEBPACK_IMPORTED_MODULE_2__/* .wave.post */ .t.post('/v3/users/mobile-passes/apple-wallet', body, {
              headers: headers,
              responseType: responseType
            });

          case 7:
            response = _context2.sent;
            data = response.data;
            type = 'application/vnd.apple.pkpass';
            passData = new Blob([data], {
              type: type
            });
            (0,file_saver__WEBPACK_IMPORTED_MODULE_1__.saveAs)(passData, 'KritikosSM.pkpass');
            return _context2.abrupt("return", {
              data: data
            });

          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](4);
            userMessage = ((_error$response2 = _context2.t0.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.userMessage) || 'Δεν μπορέσαμε να προσθέσουμε την κάρτα σου! Προσπάθησε ξανά μέσα από τη σελίδα του προφίλ σου.';
            return _context2.abrupt("return", {
              applePassWallet: {},
              applePassError: userMessage
            });

          case 19:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[4, 15]]);
  }));
  return _postAppleWallet.apply(this, arguments);
}

/***/ }),

/***/ 29250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _FormattedImage_FormattedImage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66779);
/* harmony import */ var _AddToAppleWallet_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49725);
/* harmony import */ var _AddToAppleWallet_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_AddToAppleWallet_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function AddToAppleWallet(_ref) {
  var addToAppleWallet = _ref.addToAppleWallet;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
    className: (_AddToAppleWallet_module_scss__WEBPACK_IMPORTED_MODULE_2___default().walletImageContainer),
    onClick: function onClick() {
      return addToAppleWallet();
    },
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_FormattedImage_FormattedImage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      path: "../../assets/global/add-apple-wallet.webp",
      alt: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u03C3\u03C4\u03BF apple wallet",
      width: 108,
      height: 33
    })
  });
}

/* harmony default export */ __webpack_exports__["Z"] = (AddToAppleWallet);

/***/ }),

/***/ 3805:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KM": function() { return /* binding */ PrimaryButton; },
/* harmony export */   "hG": function() { return /* binding */ BrandButton; },
/* harmony export */   "kq": function() { return /* binding */ SecondaryButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88154);
/* harmony import */ var _Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["children", "onClick"],
    _excluded2 = ["children", "onClick"],
    _excluded3 = ["children", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function PrimaryButton(_ref) {
  var children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().primaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function BrandButton(_ref2) {
  var children = _ref2.children,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref2, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().brandButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}
function SecondaryButton(_ref3) {
  var children = _ref3.children,
      _ref3$onClick = _ref3.onClick,
      onClick = _ref3$onClick === void 0 ? function () {} : _ref3$onClick,
      rest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", _objectSpread(_objectSpread({
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button), (_Buttons_module_scss__WEBPACK_IMPORTED_MODULE_4___default().secondaryButton)),
    type: "button",
    onClick: onClick
  }, rest), {}, {
    children: children
  }));
}

/***/ }),

/***/ 83686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClubCardV2; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jsbarcode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55961);
/* harmony import */ var jsbarcode__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jsbarcode__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_bi__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47516);
/* harmony import */ var _MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10625);
/* harmony import */ var _ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30041);
/* harmony import */ var _ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);









function ClubCardV2(_ref) {
  var _cn, _cn2;

  var name = _ref.name,
      points = _ref.points,
      cardNumber = _ref.cardNumber;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      flipCard = _useState[0],
      setFlipCard = _useState[1];

  function onClickCard() {
    setFlipCard(!flipCard);
  }

  var barCodeClick = 'Κάνε κλικ στο εικονίδιο για να δεις το barcode';
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    jsbarcode__WEBPACK_IMPORTED_MODULE_1___default()('.barcode').init();
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_cn = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_cn, (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().flipped), flipCard), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_cn, (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().userCard), !flipCard), _cn)),
    role: "button",
    tabIndex: "0",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_cn2 = {}, (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_cn2, (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().frontCard), !flipCard), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_cn2, (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().frontCard), !flipCard), _cn2)),
      children: !flipCard && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
        className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().opacityLayer),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().userCartPartContainer),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
            className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().userCartInfoContainer),
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
              className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().name),
              children: name
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
              className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().points),
              children: "".concat(points, " \u03A0\u03CC\u03BD\u03C4\u03BF\u03B9")
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_bi__WEBPACK_IMPORTED_MODULE_7__/* .BiBarcodeReader */ .OPD, {
            className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().barCodeIcon),
            title: barCodeClick,
            onClick: onClickCard
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
          className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().userCartPartContainer),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().logoContainer),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
            className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().userCardLowerText),
            children: "".concat("CLUB", " CARD")
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
      className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().backCard),
      onClick: onClickCard,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", {
        className: (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().backCardContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("svg", {
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()('barcode', (_ClubCardV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().barcode)) // eslint-disable-next-line react/no-unknown-property
          ,
          "jsbarcode-format": "ean13" // eslint-disable-next-line react/no-unknown-property
          ,
          "jsbarcode-value": cardNumber
        })
      })
    })]
  }, cardNumber);
}

/***/ }),

/***/ 19148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomHead; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


function CustomHead(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("title", {
      children: [title, " | ", "SUPERMARKET Κρητικός"]
    }), children]
  });
}

/***/ }),

/***/ 66779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FormattedImage; }
/* harmony export */ });
/* harmony import */ var _FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12405);
/* harmony import */ var _FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



function FormattedImage(_ref) {
  var path = _ref.path,
      alt = _ref.alt,
      width = _ref.width,
      height = _ref.height,
      loading = _ref.loading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
      srcSet: "".concat(path, "?w=").concat(width * 2, "&format=webp"),
      type: "image/webp"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
      srcSet: "".concat(path, "?w=").concat(width * 2),
      type: "image/jpeg"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
      width: width,
      height: height,
      srcSet: "".concat(path),
      className: (_FormattedImage_module_scss__WEBPACK_IMPORTED_MODULE_1___default().img),
      alt: alt,
      loading: loading
    })]
  });
}

/***/ }),

/***/ 10625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MainLogo; }
/* harmony export */ });
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61680);
/* harmony import */ var _MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function MainLogo() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
    className: (_MainLogo_module_scss__WEBPACK_IMPORTED_MODULE_1___default().logo),
    width: "160",
    height: "56",
    src: "/assets/".concat("kritikos", "/logo.svg"),
    alt: "".concat("kritikos", " logo"),
    "data-cy": "logo"
  });
}

/***/ }),

/***/ 95056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDeviceDetect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useDeviceDetect() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isMobile = _useState[0],
      setMobile = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      isAndroid = _useState2[0],
      setIsAndroid = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(),
      isIos = _useState3[0],
      setIsIos = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    var mobile = Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));
    var android = Boolean(userAgent.match(/android/i));
    var ios = Boolean(userAgent.match(/iPad|iPhone|iPod/i)) && !window.MSStream;
    setMobile(mobile);
    setIsAndroid(android);
    setIsIos(ios);
  }, []);
  return {
    isMobile: isMobile,
    isAndroid: isAndroid,
    isIos: isIos
  };
}

/***/ }),

/***/ 30482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ DigitalCardSuccess; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _google_pay_save_button_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85218);
/* harmony import */ var _google_pay_save_button_react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_google_pay_save_button_react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var universal_cookie__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(65885);
/* harmony import */ var _api_Wallet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35023);
/* harmony import */ var _api_wave_users__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71231);
/* harmony import */ var _components_AddToAppleWallet_AddToAppleWallet__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29250);
/* harmony import */ var _components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3805);
/* harmony import */ var _components_ClubCards_ClubCardV2__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83686);
/* harmony import */ var _components_CustomHead__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(19148);
/* harmony import */ var _components_MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(10625);
/* harmony import */ var _hooks_useDeviceDetect__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(95056);
/* harmony import */ var _store_loader__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(58766);
/* harmony import */ var _store_user__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73471);
/* harmony import */ var _utils_analytics__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(99700);
/* harmony import */ var _digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(53803);
/* harmony import */ var _digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
























function DigitalCardSuccess() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null),
      user = _useState[0],
      setUser = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(''),
      origin = _useState2[0],
      setOrigin = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)('success'),
      step = _useState3[0],
      setStep = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      error = _useState4[0],
      setError = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(''),
      errorMessage = _useState5[0],
      setErrorMessage = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false),
      walletError = _useState6[0],
      setWalletError = _useState6[1];

  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(''),
      walletErrorMessage = _useState7[0],
      setWalletErrorMessage = _useState7[1];

  var _useDeviceDetect = (0,_hooks_useDeviceDetect__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(),
      isAndroid = _useDeviceDetect.isAndroid,
      isIos = _useDeviceDetect.isIos;

  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)({}),
      googleJWT = _useState8[0],
      setGoogleJWT = _useState8[1];

  var cookies = new universal_cookie__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z();
  var AddressView = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function () {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(9979), __webpack_require__.e(5642), __webpack_require__.e(7536), __webpack_require__.e(3988), __webpack_require__.e(2998), __webpack_require__.e(8790)]).then(__webpack_require__.bind(__webpack_require__, 82998));
  }, {
    ssr: false,
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(82998)];
      }
    }
  });

  function addAddressRequest(_x) {
    return _addAddressRequest.apply(this, arguments);
  }

  function _addAddressRequest() {
    _addAddressRequest = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(newAddress) {
      var addressToCreate, token, response;
      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setError('');
              (0,_utils_analytics__WEBPACK_IMPORTED_MODULE_18__/* .addToAnalytics */ .z2)('addAddres', undefined, [['option', 'submit']]);
              addressToCreate = {
                address: [_objectSpread({}, newAddress)]
              };
              token = cookies.get('token');
              _context3.next = 6;
              return (0,_api_wave_users__WEBPACK_IMPORTED_MODULE_9__/* .createAddressUser */ .hE)(token, addressToCreate);

            case 6:
              response = _context3.sent;

              if (!(typeof response === 'string' || response !== null && response !== void 0 && response.error)) {
                _context3.next = 11;
                break;
              }

              setError(true);
              setErrorMessage(response.error);
              return _context3.abrupt("return");

            case 11:
              _store_user__WEBPACK_IMPORTED_MODULE_17__/* ["default"].addAddress */ .Z.addAddress(response === null || response === void 0 ? void 0 : response.address);
              router.push('/', '/');

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _addAddressRequest.apply(this, arguments);
  }

  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function () {
    if (router.isReady) {
      setOrigin(router.query.origin);
    }
  }, [router.isReady]);
  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function () {
    var user$ = _store_user__WEBPACK_IMPORTED_MODULE_17__/* ["default"].subscribe */ .Z.subscribe( /*#__PURE__*/function () {
      var _ref = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee(_user) {
        return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(_user)) {
                  _context.next = 3;
                  break;
                }

                router.replace('/');
                return _context.abrupt("return");

              case 3:
                setUser(_user);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }());
    return function () {
      return user$.unsubscribe();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function () {
    function addToGoogleWallet() {
      return _addToGoogleWallet.apply(this, arguments);
    }

    function _addToGoogleWallet() {
      _addToGoogleWallet = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
        var _yield$postGoogleWall, googleJwt, gWalletError;

        return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _store_loader__WEBPACK_IMPORTED_MODULE_16__/* ["default"].addEvent */ .Z.addEvent('GOOGLE_WALLET');
                _context2.next = 3;
                return (0,_api_Wallet__WEBPACK_IMPORTED_MODULE_8__/* .postGoogleWallet */ .P)(user === null || user === void 0 ? void 0 : user.loyaltyCards[0].cardId);

              case 3:
                _yield$postGoogleWall = _context2.sent;
                googleJwt = _yield$postGoogleWall.googleJwt;
                gWalletError = _yield$postGoogleWall.gWalletError;

                if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(googleJwt)) {
                  setGoogleJWT(googleJwt);
                } else {
                  setWalletError(true);
                  setWalletErrorMessage(gWalletError);
                }

                _store_loader__WEBPACK_IMPORTED_MODULE_16__/* ["default"].removeEvent */ .Z.removeEvent('GOOGLE_WALLET');

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _addToGoogleWallet.apply(this, arguments);
    }

    if (isAndroid) addToGoogleWallet();
  }, [isAndroid]);

  function addToAppleWallet() {
    return _addToAppleWallet.apply(this, arguments);
  }

  function _addToAppleWallet() {
    _addToAppleWallet = (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee4() {
      var _yield$postAppleWalle, applePassWallet, applePassError;

      return _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0,_api_Wallet__WEBPACK_IMPORTED_MODULE_8__/* .postAppleWallet */ .T)(user === null || user === void 0 ? void 0 : user.loyaltyCards[0].cardId);

            case 2:
              _yield$postAppleWalle = _context4.sent;
              applePassWallet = _yield$postAppleWalle.applePassWallet;
              applePassError = _yield$postAppleWalle.applePassError;

              if (lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(applePassWallet) && applePassError) {
                setWalletError(true);
                setWalletErrorMessage(applePassError);
              }

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return _addToAppleWallet.apply(this, arguments);
  }

  function clickSuccess() {
    if (origin === 'register') {
      setStep('address');
    } else {
      router.push('/');
    }
  }

  if (!(user !== null && user !== void 0 && user._id)) return null;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)("section", {
    className: step === 'address' ? (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().addressContainer) : (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().container),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_CustomHead__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
      title: "\u03A3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 Digital Card/ \u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE Digital Card"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
      className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().logoContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
        href: "/",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_MainLogo_MainLogo__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {})
        })
      })
    }), step === 'success' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("h1", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().header),
        children: origin === 'login' ? 'Βρήκαμε την κάρτα σου!' : 'Αυτή είναι η κάρτα σου!'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().cardContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_ClubCards_ClubCardV2__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          name: user === null || user === void 0 ? void 0 : user.fullName,
          points: user === null || user === void 0 ? void 0 : user.loyaltyCards[0].points,
          cardNumber: user === null || user === void 0 ? void 0 : user.loyaltyCards[0].cardId
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("p", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().p),
        children: origin === 'register' ? 'Μόλις απέκτησες τη δική σου ψηφιακή κάρτα και μπορείς πλέον να την έχεις πάντα μαζί στο κινητό σου' : 'Η κάρτα σου μόλις μετατράπηκε σε ψηφιακή για να την έχεις πάντα μαζί στο κινητό σου.'
      }), isAndroid && !walletError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().addToGPayContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)((_google_pay_save_button_react__WEBPACK_IMPORTED_MODULE_2___default()), {
          jwt: googleJWT,
          size: "matchparent",
          height: "standard"
        })
      }), isIos && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().walletImageContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_AddToAppleWallet_AddToAppleWallet__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
          addToAppleWallet: addToAppleWallet
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("div", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().primaryButtonContainer),
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("a", {
          className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().fullWidth),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(_components_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_11__/* .PrimaryButton */ .KM, {
            onClick: function onClick() {
              return clickSuccess();
            },
            "data-cy": "success-digital",
            style: {
              width: '100%'
            },
            children: origin === 'register' ? 'Δες πώς εξυπηρετείσαι' : 'Συνέχισε τις αγορές σου!'
          })
        })
      }), walletError && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("p", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().errorSmallText),
        children: walletErrorMessage
      })]
    }), origin === 'register' && step === 'address' && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("h1", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().addressHeader),
        children: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7\u03C2"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("p", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().addressText),
        children: "\u03A3\u03C5\u03BC\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B5 \u03C4\u03B1 \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03B1 \u03C4\u03B7\u03C2 \u03B4\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03AE\u03C2 \u03C3\u03BF\u03C5 \u03BA\u03B1\u03B9 \u03B4\u03B5\u03C2 \u03C0\u03CE\u03C2 \u03B5\u03BE\u03C5\u03C0\u03B7\u03C1\u03B5\u03C4\u03B5\u03AF\u03C3\u03B1\u03B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)(AddressView, {
        submitForm: addAddressRequest
      }), error && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__.jsx)("p", {
        className: (_digital_card_success_module_scss__WEBPACK_IMPORTED_MODULE_22___default().errorSmallText),
        children: errorMessage
      })]
    })]
  });
}

/***/ }),

/***/ 33852:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digital-card-success",
      function () {
        return __webpack_require__(30482);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 49725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"walletImageContainer":"AddToAppleWallet_walletImageContainer__7JQgo"};

/***/ }),

/***/ 88154:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Buttons_button__qYN03","primaryButton":"Buttons_primaryButton__7N3x3","brandButton":"Buttons_brandButton__cCp9d","secondaryButton":"Buttons_secondaryButton__ruBI_"};

/***/ }),

/***/ 30041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"ClubCardV2_section__NZoOv","cardsContainer":"ClubCardV2_cardsContainer__KyFAO","clubCard":"ClubCardV2_clubCard__6gFyJ","userCard":"ClubCardV2_userCard__G_q5_","frontCard":"ClubCardV2_frontCard__v3ftt","opacityLayer":"ClubCardV2_opacityLayer__n0QC0","flipped":"ClubCardV2_flipped__bDNDy","backCard":"ClubCardV2_backCard__s_DZy","backCardContainer":"ClubCardV2_backCardContainer__SFNOO","userCartPartContainer":"ClubCardV2_userCartPartContainer__d0sFI","name":"ClubCardV2_name__pkXMA","points":"ClubCardV2_points__5PP9v","barCodeIcon":"ClubCardV2_barCodeIcon__KFPMe","userCartInfoContainer":"ClubCardV2_userCartInfoContainer__O61Tz","userCardUpperContent":"ClubCardV2_userCardUpperContent__lxquS","userPoints":"ClubCardV2_userPoints__TGSn7","userText":"ClubCardV2_userText__fl62h","userCardLowerContent":"ClubCardV2_userCardLowerContent__QUq1A","userCardLowerText":"ClubCardV2_userCardLowerText__vx9bL","logoImg":"ClubCardV2_logoImg__4K_Qg","circlePlusContainer":"ClubCardV2_circlePlusContainer__jjjEr","circlePlusIcon":"ClubCardV2_circlePlusIcon__dmiCX","modalHeader":"ClubCardV2_modalHeader__2dzIY","barcode":"ClubCardV2_barcode__OMGHi","logoContainer":"ClubCardV2_logoContainer__kb_H8"};

/***/ }),

/***/ 12405:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"img":"FormattedImage_img__ai6L8"};

/***/ }),

/***/ 61680:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLogo_logo__zTYp1"};

/***/ }),

/***/ 53803:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"addressContainer":"digital-card-success_addressContainer__1Dm21","container":"digital-card-success_container__i5JEz","logoContainer":"digital-card-success_logoContainer___vYow","header":"digital-card-success_header__UjOm_","addressHeader":"digital-card-success_addressHeader___ZUvs","p":"digital-card-success_p__dqdWu","addressText":"digital-card-success_addressText__13etn","fullWidth":"digital-card-success_fullWidth___y_n9","primaryButtonContainer":"digital-card-success_primaryButtonContainer__P3_iV","cardContainer":"digital-card-success_cardContainer__8wWch","walletImageContainer":"digital-card-success_walletImageContainer__fPkET","addToGPayContainer":"digital-card-success_addToGPayContainer__psRNr","errorSmallText":"digital-card-success_errorSmallText__jAWIq"};

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ }),

/***/ 4730:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
;// CONCATENATED MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3874,3996,5790,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(33852); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);